<template>
  <div>
    <table id="report-table">
      <tr class="title">
        <!-- <td style="width: 30px">
          <Checkbox  @on-change="selectAll" :value="ischeckAll"></Checkbox>
        </td> -->
        <td style="width: 160px">医院名称</td>
        <td style="width: 60px">姓名</td>
        <td style="width: 60px">年龄</td>
        <td style="width: 40px">性别</td>
        <td style="width: 120px">手机号码</td>
        <td style="width: 200px">身份证号码</td>
        <td style="width: 120px">预约类型</td>
        <td style="width: 200px">预约时间</td>
        <td>是否去过中高风险地区</td>
        <td style="width: 60px">男方姓名</td>
        <td style="width: 120px">男方手机号</td>
        <td style="width: 200px">男方身份证</td>
        <td>陪检人员体温</td>
        <td>儿童体温</td>
        <td style="width: 160px">备注</td>
        <!-- <td style="width: 200px">创建时间</td> -->

        <!-- <td style="width: 60px">打印状态</td>
        <td style="width: 180px">操作</td> -->
      </tr>
      <tbody v-if="getTable.length == 0">
        <tr>
          <td colspan="11">暂时没有数据</td>
        </tr>
      </tbody>
      <tbody else id="td" v-for="(item, index) in getTable" :key="index">
        <tr>
          <!-- <td >
            <Checkbox
              :value="item.checked"
              @on-change="$emit('selectItem',item.orderId)"
            ></Checkbox>
          </td> -->
          <td>{{ item.hospitalName }}</td>
          <td>{{ item.name }}</td>
          <td>{{ item.age }}{{ item.ageUnit }}</td>
          <td>{{ (item.sex + "") | dictionaryValue(sexList) }}</td>
          <td>{{ item.mobile }}</td>
          <!-- <td
            :title="item.hospitalName?item.hospitalName:''"
          >{{item.hospitalName}}</td> -->
          <td>{{ item.idNumber }}</td>
          <td>{{ item.type }}</td>
          <td>
            {{ item.appointmentDate }}&nbsp;&nbsp;{{ item.appointmentTime }}
          </td>
          <td>{{ item.isMediumHigh == 0 ? "否" : "是" }}</td>
          <td>{{ item.menName }}</td>
          <td>{{ item.menMobile }}</td>
          <td>{{ item.menIdNumber }}</td>
          <td>{{ item.accompanyBody }}</td>
          <td>{{ item.childBody }}</td>

          <td>{{ item.remark }}</td>
          <!-- <td>{{ item.createTime | formatDate("01", "03") }}</td> -->

          <!-- :rowspan="item.orderReport.length==0?1:item.orderReport.length" -->
          <!-- <td v-if="item.orderReport.length==0?1:item.orderReport.length">
              <span @click="printReport(item.orderReport,item.reportTitle,item.orderReport[0].orderReportId)">预览</span> 
              <span @click="SeeReport(item.orderReport,item.reportTitle,item.orderReport[0].orderReportId)">打印</span> 
              <span @click="LODOPSeeport(item.orderReport,item.reportTitle,item.orderReport[0].orderReportId)">LODOP打印</span>
            </td> -->
        </tr>
        <!-- <template v-for="(m,i) in item.orderReport">
          <tr :key="i" v-if="!i==0">
            <td>{{m.specimenBarcode}}</td>
            <td>{{m.projectName}}</td>
            <td>{{m.reportTime|formatDate('01','03')}}</td>
            <td>{{m.printState}}</td>
             <td>
            <span @click="printReport11(m,m.orderReportId)">预览</span> 
            <span @click="SeeReport11(m,m.orderReportId)">打印</span>
            <span @click="LODOPSeeport11(m,m.orderReportId)">LODOP打印11</span>
          </td>
            
          </tr>
        </template> -->
      </tbody>
    </table>
  </div>
</template>

<script>
import { isSingleItem } from "../../api/clinic";
import {
  provinceList,
  nextList,
  selectDictDataListByDictCode,
} from "./../../api/common.js";
import { formatDate, tips, dictionaryValue } from "./../../tools";
export default {
  name: "reportTable",
  data() {
    return {
      sexList: [],
    };
  },
  props: {
    getTable: {
      type: Array,
      default: () => [],
    },
    ischeckAll: {
      type: Boolean,
    },
  },

  filters: {
    formatDate,
    dictionaryValue,
  },
  mounted() {
    console.log(this.getTable);
    this.getSex();
  },
  methods: {
    selectAll(e) {
      this.$emit("selectAll", e);
    },
    printReport(arr, reportTitle, orderReportId) {
      console.log(arr, reportTitle, orderReportId);
      this.$emit("printReport", { arr, reportTitle, orderReportId });
    },
    printReport11(m, orderReportId) {
      console.log(m, orderReportId);
      this.$emit("printReport11", { m, orderReportId });
    },
    SeeReport11(m, orderReportId) {
      this.$emit("SeeReport11", { m, orderReportId });
    },
    SeeReport(arr, reportTitle, orderReportId) {
      this.$emit("SeeReport", { arr, reportTitle, orderReportId });
    },
    orderDetail(id) {
      this.$emit("detail", id);
    },
    LODOPSeeport(arr, reportTitle, orderReportId) {
      this.$emit("LODOPSeeport", { arr, reportTitle, orderReportId });
    },
    LODOPSeeport11(m, orderReportId) {
      this.$emit("LODOPSeeport11", { m, orderReportId });
    },
    //性别
    getSex() {
      let _this = this;
      selectDictDataListByDictCode({
        typeCode: "sex",
      }).then((res) => {
        if (res.code == 0) {
          // console.log(res.data);
          _this.sexList = res.data;
        } else {
          tips(_this, res.msg, "warning");
        }
      });
    },
  },
};
</script>
       
<style lang='less' scoped>
table,
td {
  border: 1px solid #ddd;
}
#report-table {
  border-collapse: collapse;
  // width: 100%;
  overflow: auto;
}
#report-table,
#report-table th,
#report-table td {
  border: 1px solid #e8eaec;
  text-align: center;
}
#report-table span {
  cursor: pointer;
  text-align: center;
  margin: 0px 5px;
  // border: 1px solid rgb(39, 120, 231);
  // color: rgb(39, 120, 231);
  border: 1px solid #3985BE;
  color:  #3985BE;
  padding: 0 7px;
  font-size: 12px;
  border-radius: 3px;
  white-space: nowrap;
  height: 32px;
  line-height: 32px;
  display: inline-block;
}

#report-table td,
#report-table {
  padding: 10px 0;
}
#report-table {
  background-color: #fff;
}
#report-table .title {
  background-color: #f8f9fb;
}
table {-
  table-layout: fixed;
}
td {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
@media screen and (max-width: 1600px){
    #report-table{
        font-size: 12px;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/appointments/YnTable.vue